import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";

import PropTypes from 'prop-types';
// import classnames from 'classnames';

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
// import red from '@material-ui/core/colors/red';
import Button from 'components/CustomButtons/Button.jsx';
import Accordion from "components/Accordion/Accordion.jsx";
// import Tooltip from "@material-ui/core/Tooltip";

// images
// import avatarImg from "images/avatars/avatar_me.jpg";
// import Avatar from "@material-ui/core/Avatar";
// Material kit
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
// import CardAvatar from "components/Card/CardAvatar.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import Muted from "components/Typography/Muted.jsx";
import Badge from "components/Badge/Badge.jsx";
// Sections
import UserTable from "./UserTable.jsx"

// import {
//   Phone,
//   MailOutline,
//   ThumbUpAlt,
//   StarRate
// } from '@material-ui/icons';

// import { Facebook, Google, Twitter, GithubCircle } from 'mdi-material-ui';

const styles = theme => ({
  label: {
    marginRight: '10px'
  }
});

class UserData extends React.Component {
  state = { expanded: false };

  handleExpandClick = () => {
    this.setState(state => ({ expanded: !state.expanded }));
  };

  render() {
    const { classes } = this.props;
    const { profile } = this.props;
    return (
      <Grid container
        // alignItems='center'
        spacing={8}
        justify="flex-start">

        <GridItem
          lg={4}
          md={4}
          xl={4}
          xs={4}
          >
          <Card profile className={classes.card3}>
            <GridContainer>
              <GridItem xs={12} sm={5} md={5}>
                <CardHeader image>
                  <a href="#pablo" onClick={e => e.preventDefault()}>
                    <img src={profile.attributes.avatar} alt="..." />
                  </a>
                  <div
                    className={classes.coloredShadow}
                    style={{
                      backgroundImage: `url(${profile.attributes.avatar})`,
                      opacity: "1"
                    }}
                  />
                </CardHeader>
              </GridItem>
              <GridItem xs={12} sm={7} md={7}>
                <CardBody plain>
                  <h4 className={classes.cardTitle}>{profile.attributes.first_name} {profile.attributes.last_name}</h4>
                  <Muted>
                    <h6 className={classes.cardCategory}>CEO - CO FOUNDER</h6>
                  </Muted>

                  <p className={classes.description}>
                    {profile.attributes.description}
                  </p>

                  <Divider variant="middle" />

                  <p>
                    <i className={" fas fa-envelope"} />{" "} {profile.attributes.email}
                  </p>
                  <p>
                    <i className={" fas fa-phone"} />{" "}  {profile.attributes.phone_number}
                  </p>


                </CardBody>
                <CardFooter profile plain>
                  <Button justIcon simple color="twitter">
                    <i className="fab fa-twitter" />
                  </Button>
                  <Button justIcon simple color="facebook">
                    <i className="fab fa-facebook-square" />
                  </Button>
                  <Button justIcon simple color="google">
                    <i className="fab fa-google" />
                  </Button>
                </CardFooter>
              </GridItem>
            </GridContainer>
          </Card>

        </GridItem>

        <GridItem
          lg={1}
          md={1}
          xl={1}
          xs={1}></GridItem>

        <Grid item
        lg={7}
        md={7}
        xl={7}
        xs={7}>

          <Grid container>

            <Grid item
            lg={12}
            md={12}
            xl={12}
            xs={12}>
              <Typography className={classes.label} variant="body2" inline align="left" color="textPrimary" gutterBottom>
                Address:
              </Typography>
              <Typography inline align="left" variant="body1" color="textSecondary" gutterBottom>
                {profile.attributes.full_address}
              </Typography>
            </Grid>

            <Grid item
            lg={6}
            md={6}
            xl={6}
            xs={6}>
              <Typography className={classes.label} inline align="left" variant="body2"  color="textPrimary" gutterBottom>
                ID:
              </Typography>
              <Typography inline align="left" variant="body1"  color="textSecondary" gutterBottom>
                {profile.attributes.id_number} {profile.attributes.id_number_type}
              </Typography>
            </Grid>

            <Grid item
            lg={6}
            md={6}
            xl={6}
            xs={6}>
              <Typography className={classes.label} inline align="left" variant="body2"  color="textPrimary" gutterBottom>
                VAT number:
              </Typography>
              <Typography inline align="left" variant="body1"  color="textSecondary" gutterBottom>
                {profile.attributes.vat_number} {profile.attributes.vat_number_country_code}
              </Typography>
            </Grid>

            <Grid item
            lg={1}
            md={1}
            xl={1}
            xs={1}>
            <Typography className={classes.label} inline align="left" variant="body2"  color="textPrimary" gutterBottom>
              Locale:
            </Typography>
            <Typography inline align="left" variant="body2"  color="textSecondary" gutterBottom>
              {profile.attributes.locale}
            </Typography>
            </Grid>

            <Grid item
            lg={1}
            md={1}
            xl={1}
            xs={1}>
            <Typography className={classes.label} inline align="left" variant="body2"  color="textPrimary" gutterBottom>
              Lang:
            </Typography>
            <Typography inline align="left" variant="body2"  color="textSecondary" gutterBottom>
              {profile.attributes.lang}
            </Typography>
            </Grid>

            <Grid item
            lg={9}
            md={9}
            xl={9}
            xs={9}>
              <Typography className={classes.label} inline align="left" variant="body2"  color="textPrimary" gutterBottom>
                Languages:
              </Typography>
              <Typography inline align="left" variant="body1"  color="textSecondary" gutterBottom>
                Spanish: Native, English: Hight Spoken and Writen, French: Basic, German: Basic
              </Typography>
            </Grid>

            <Grid item
            lg={12}
            md={12}
            xl={12}
            xs={12}>
              <Typography className={classes.label} inline align="left" variant="body2"  color="textPrimary" gutterBottom>
                Notes:
              </Typography>
              <Typography inline align="left" variant="body1"  color="textSecondary" gutterBottom>
                {profile.attributes.notes}
              </Typography>
            </Grid>

            <Grid item
            lg={12}
            md={12}
            xl={12}
            xs={12}>
              <Typography className={classes.label} inline align="left" variant="body2"  color="textPrimary" gutterBottom>
                Public name:
              </Typography>
              <Typography inline align="left" variant="body1"  color="textSecondary" gutterBottom>
                {profile.attributes.public_name}
              </Typography>
            </Grid>

            <Grid item
            lg={12}
            md={12}
            xl={12}
            xs={12}>
              <Typography className={classes.label} inline align="left" variant="body2"  color="textPrimary" gutterBottom>
                Public description:
              </Typography>
              <Typography inline align="left" variant="body1"  color="textSecondary" gutterBottom>
                {profile.attributes.public_description}
              </Typography>
            </Grid>

            <Grid item
              lg={1}
              md={1}
              xl={1}
              xs={1}>

                { profile.attributes.active === true
                  ? <Badge color="success">active</Badge>
                  : <Badge>inactive</Badge>
                }

            </Grid>

            <Grid item
              lg={5}
              md={5}
              xl={5}
              xs={5}>

              { profile.attributes.public === true
                ? <Badge color="success">public</Badge>
                : <Badge>private</Badge>
              }
            </Grid>

            <Grid item
            lg={1}
            md={1}
            xl={1}
            xs={1}>

              <Button color="facebook" simple>
                <i className={" fas fa-heart"} />{" "} {profile.attributes.likes}
              </Button>

            </Grid>

            <Grid item
            lg={1}
            md={1}
            xl={1}
            xs={1}>

              <Button color="facebook" simple>
                <i className={" fas fa-user-plus"} />{" "} {profile.attributes.rating}
              </Button>
            </Grid>

            <Grid item
              lg={12}
              md={12}
              xl={12}
              xs={12}
              >
              <Accordion
                active={-1}
                collapses={[
                  {
                    title: " Recent acctions",
                    content:
                    <UserTable />
                  },
                  {
                    title: " Recent oportunities",
                    content:
                      <UserTable />
                  },
                  {
                    title: " Track data",
                    content:
                      <UserTable />
                  }
                ]}
                />
            </Grid>



        </Grid>
        </Grid>
      </Grid>

    );
  }
}

UserData.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(UserData);
